import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export interface BankAccount {
  id: string
  bankType: string
  bankName: string | null
  ibanOrShebaNumber: string | null
  bicOrCardNumber: string | null
  iranianBankType?: string | null
  isIranian: boolean
  isPound: boolean
  isVerified: number
  ownerFullName: string
  nationalCode?: string | null
  birthDate?: string | null
  paypalEmail?: string | null
  paypalId?: string | null
  revolutTag?: string | null
  bankAccountNumber?: string | null
  bankAccountSortCode?: string | null
  countryUuid?: string | null
}

export interface Pagination {
  currentPage: number
  lastPage: number
  perPage: number
  total: number
  hasNextPage: boolean
  hasPrevPage: boolean
}

export function getUserBankAccountsAction(
  userUuid: string,
  page: number = 1
): Promise<ApiPaginationResponse<BankAccount[]>> {
  const params = new URLSearchParams()
  params.append('page', String(page))

  const url = `/bank-accounts/${userUuid}?${params.toString()}`
  return api.get<ApiPaginationResponse<BankAccount[]>>(url)
}
